<template>
  <div class="propertyoffice">
    <div class="header">
      <div class="title">物业移动、协同办公</div>
      <div class="border"></div>
    </div>
    <div class="body">
      <div class="left">
        <div class="logo">
          <img :src="propertyoffice1" alt="" />
        </div>
        <div class="position">
          <img :src="propertyoffice2" alt="" />
          <img :src="propertyoffice3" alt="" />
          <img :src="propertyoffice4" alt="" />
        </div>
      </div>

      <div class="right">
        涵盖所有物业办公场景，帮助物业实现线上移动办公，省时省力，为物业管理降本增效。
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import propertyoffice1 from "../../../../assets/product/propertyoffice1.png";
import propertyoffice2 from "../../../../assets/product/propertyoffice2.png";
import propertyoffice3 from "../../../../assets/product/propertyoffice3.png";
import propertyoffice4 from "../../../../assets/product/propertyoffice4.png";

export default {
  setup() {
    return reactive({
      propertyoffice1: propertyoffice1,
      propertyoffice2: propertyoffice2,
      propertyoffice3: propertyoffice3,
      propertyoffice4: propertyoffice4,
    });
  },
};
</script>

<style scoped>
.propertyoffice {
  width: 1180px;
  margin: 80px auto 0;
}
.header .title {
  font-size: 30px;
  text-align: center;
}
.header .border {
  width: 40px;
  height: 5px;
  background: #248efb;
  margin: 20px auto 0;
}

.body {
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
}
.body .left {
  display: flex;
  position: relative;
}
.body .left .logo img {
  width: 332px;
  margin-right: 20px;
}
.body .left .position img {
  width: 236px;
  position: absolute;
}
.body .left .position img:nth-of-type(1) {
  left: 100%;
}
.body .left .position img:nth-of-type(2) {
  left: 125%;
  bottom: 0;
}
.body .left .position img:nth-of-type(3) {
  left: 150%;
  bottom: 0;
}
.body .right {
    width: 480px;
    font-size: 16px;
    color: #3D3D3D;
    line-height: 24px;
}
</style>
